import { render, staticRenderFns } from "./CarepForm.vue?vue&type=template&id=18fd4316&scoped=true"
import script from "./CarepForm.vue?vue&type=script&lang=js"
export * from "./CarepForm.vue?vue&type=script&lang=js"
import style0 from "./CarepForm.vue?vue&type=style&index=0&id=18fd4316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fd4316",
  null
  
)

export default component.exports